var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{scopedSlots:_vm._u([{key:"brand",fn:function(){return [_c('b-navbar-item',{attrs:{"tag":"router-link","to":{ path: '/' }}},[_c('h1',[_vm._v("TOM-ID")])])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }